import { NDS_CALC } from '../global-constants.js';

const activateDealStarter = (vehicle) => {
	const {
		finalPrice,
		inventoryType,
		msrp,
		uuid
	} = vehicle;

	// Update Inventory data
	window.caiEventBus.emit('wallet:setInventory', {
		inventory: {
			id: uuid,
			pricingDetail: {
				salePrice: finalPrice,
				msrp
			},
			type: inventoryType
		}
	});
}

export const insertDealStarter = (API, walletScriptHost, config) => {
	API.subscribe('vehicle-shown-v1', ev => {
		const { payload: vehicle } = ev;
		const { walletTheme } = config;
		API.insert('secondary-content', async (elem) => {
			const ndsCalc = document.createElement(NDS_CALC);
			if (walletTheme) {
				ndsCalc.setAttribute('theme', walletTheme);
			}
			API.append(elem, ndsCalc);

			await API.loadJS(`${walletScriptHost}/${NDS_CALC}.js`);
			activateDealStarter(vehicle);
		});
	});
}
